<template lang="html">
  <section class="form-box" :class="{incompleted: srcLang.length < 1 || targLangs.length < 1}">
    <div class="container">

      <div class="row">
        <h2 class="urlap-title">Nyelvek kiválasztása</h2>
      </div>
      <div class="row">
        <h6>
          Forrásnyelv<span class="required-field">*</span>
        </h6>
        <div class="form-box-item" :class="{invalid: srcLang.length < 1}">
          <button class="lang-select" type="button" @click="enablePopup()" :class="{locked: files.length > 0}">
            {{ srcLangLabel }}
            <span class="glyphicon glyphicon-chevron-down"></span>
          </button>
        </div>
        <div class="ico ico-full">
          <img src="/wp-content/themes/lebe-childtheme/assets/images/ico/arrow.png" alt="">
        </div>
        <h6>
          Célnyelv(ek)<span class="required-field">*</span>
        </h6>
        <div class="form-box-item" :class="{invalid: targLangs.length < 1}">
          <button class="lang-select" type="button" @click="enableLanguagesPopup()" :class="{locked: files.length > 0}">
            {{ tgtLangLabel }}
            <span class="glyphicon glyphicon-chevron-down"></span>
          </button>
        </div>
      </div>

    </div>
    <LanguagePopup
      v-if="showPopup"
      :options="fieldOptions"
      :show.sync="showPopup"
      :lang.sync="srcLang"
    />
    <LanguagesPopup
      v-if="showPopupLangs"
      :options="targetLanguages"
      :show.sync="showPopupLangs"
      :lang.sync="targLangs"
    />
  </section>

</template>

<script>
import {fieldMixin} from '../../mixin/field'
import Vue from 'vue'
import LanguagePopup from '../Popup/LanguagePopup'
import LanguagesPopup from '../Popup/LanguagesPopup'

Vue.component('LanguagePopup', LanguagePopup)
Vue.component('LanguagesPopup', LanguagesPopup)


export default {
  data: function(){
    return {
      targLangs$: [],
      srcLang$: '',
      showPopup: false,
      showPopupLangs: false
    }
  },
  mixins: [
    fieldMixin
  ],
  components: [
    LanguagePopup,
    LanguagesPopup
  ],
  props: [
    'srcLanguage',
    'tgtLanguage',
    'files'
  ],
  created() {
    //init values
    this.targLangs$ = this.tgtLanguage
    this.srcLang$ = this.srcLanguage
  },
  computed: {
    targetLanguages() {
      let langs = []
      for(let key in this.fieldOptions) {
        if(key != this.srcLang$) {
          langs.push({
            value: key,
            label: this.fieldOptions[key].label
          })
        }
      }
      return langs
    },
    srcLang: {
      get() {
        return this.srcLang$
      },
      set(val) {
        this.srcLang$ = val
        this.$emit(`update:srcLanguage`,val)
        let
          find = false,
          langs = []
        //forrásnyelv kivétele
        this.targLangs.forEach(( item ) => {
          if(item.value != this.srcLang) {
            langs.push(item)
          } else {
            find = true
          }
        })
        if(find){
          this.targLangs = langs
        }
      }
    },
    targLangs: {
      get() {
        return this.targLangs$
      },
      set(val) {
        let langs = []
        //forrásnyelv kivétele, ha benne van
        val.forEach((item) => {
          if(item.value != this.srcLang) {
            langs.push(item)
          }
        });
        this.targLangs$ = langs

        this.$emit(`update:tgtLanguage`,langs)
      }
    },
    srcLangLabel() {
      let label = 'Választás'
      if(this.srcLang) {
        for(const langKey in this.fieldOptions) {
          if(this.srcLang == langKey) {
            label = this.fieldOptions[langKey].label
            break
          }
        }
      }
      return label
    },
    tgtLangLabel() {
      let
        label = 'Választás',
        labels = []
      if( Array.isArray(this.tgtLanguage) && this.tgtLanguage.length > 0) {
        this.tgtLanguage.forEach(elem =>{
          labels.push(elem['label'])
        })
        label = labels.join(', ')
      }
      return label
    }
  },
  methods: {
    enablePopup() {
      if(this.files.length == 0) {
        this.showPopup = true
      }
    },
    enableLanguagesPopup() {
      this.showPopupLangs = true
    }
  }
}
</script>
<style lang="scss" >
@import "vue-select/src/scss/vue-select.scss";
.vue-select{
  .vs__selected-options{
    flex-wrap: inherit;
  }
  .vs__deselect{
    align-items: center;
  }
  /* lebe override*/
  input[type="text"], input[type="email"], input[type="password"], input[type="tel"], input[type="search"], button, input[type="submit"]{
    line-height:  30px !important;
    height:  initial !important;
  }
}
.form-box-item.target-languages{
  overflow: visible;
}
button.lang-select {
  width: 100%;
  line-height: normal;
  height: 35px;
  background: white;
  text-align: left;
  color: #555;
  text-transform: none;
  font-weight: normal;
  padding-right: 8px;
  &.locked{
    background: #eee;
  }
  span.glyphicon{
    float: right;
    opacity: .6;
    margin-top: 3px;
  }
}
</style>
